import { render, staticRenderFns } from "./MemberHead.vue?vue&type=template&id=6f8145ac&"
import script from "./MemberHead.vue?vue&type=script&lang=js&"
export * from "./MemberHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports